import { Box, Flex, FlexProps } from "@chakra-ui/react";
import { MAX_CONTENT_WIDTH, SITE_MIN_MARGIN } from "../const";

export const PageHeader: React.FC<FlexProps> = (props) => (
  <Box
    bg="gray.50"
    borderBottomWidth="1px"
    borderTopWidth="1px"
    py={6}
    px={SITE_MIN_MARGIN}
    mb={2}
    lineHeight="35px"
    fontSize="28px"
  >
    <Flex maxW={MAX_CONTENT_WIDTH} mx="auto" {...props} />
  </Box>
);
